import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface EmptyStateContainerProps extends React.ComponentPropsWithRef<'div'> {
  children: ReactNode;
}

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: var(--cc_size_spacing_xxl) auto;
`;

const EmptyStateContainer: React.FC<EmptyStateContainerProps> = ({
  children,
  ...divTagProps
}) => {
  return <StyledDiv {...divTagProps}>{children}</StyledDiv>;
};

export default EmptyStateContainer;
